import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Row, Spin, DatePicker, Button } from "antd";
import moment from "moment";
import Pdf from "imgtopdf";
import FileSaver from "file-saver";
import "./index.scss";

import Room from "./rooms";
import Food from "./food";
import Staff from "./Staff";
import Title from "../home/title";
import Cost from "./Cost";
import Day from "./Day";
import Month from "./Month";
import NetworkRating from "./NetworkRating";

const { imgToPdf } = Pdf;

@inject('store')
@observer
class index extends Component {
    state = {
        date: moment().subtract(1, 'month').format('YYYY-MM-DD'),
        print: false
    }
    componentDidMount() {
        this.props.store.general.getData(
            moment(this.state.date).format('YYYY'),
            moment(this.state.date).format('M'),
            moment(this.state.date).format('w')
        );
        window.addEventListener('resize', () => {
            if (window.location.hash === '#/table/general') {
                this.props.store.general.onResize();
            }
        });
    }
    onExport = async () => {
        try {
            await this.setState({ print: true });
            const data = await imgToPdf("general_bi", 1.5);

            let dataFrom = new FormData();
            dataFrom.append('img', data['img']);
            dataFrom.append('height', data['canvas'].height);
            dataFrom.append('width', data['canvas'].width);
            let headres = {
                method: 'post',
                credentials: 'include',
                headers: {},
                body: dataFrom
            }
            let res = await fetch('/imgToPdf', headres);
            let j = await res.blob();

            let file = new Blob([j], { type: "application/pdf" });
            FileSaver.saveAs(file, `BI Structure - Hotel 酒店数据平台 ${this.state.date}.pdf`);

            await this.setState({ print: false });
        } catch (error) {
            this.setState({ print: false });
            console.error(error);
        }
    }

    render() {
        const { loading, getData } = this.props.store.general;
        const { date, print } = this.state;
        const dateFormat = "YYYY-MM-DD";
        return (
            <Spin tip="加载中..." spinning={loading || print}>
                <div className="general BI_chart" id="general_bi">
                    <Row className="title">
                        BI Structure - Hotel 酒店数据平台
                        <span className="bi-date">
                            <DatePicker
                                defaultValue={moment(date, dateFormat)}
                                format={dateFormat}
                                onChange={(m, s) => {
                                    getData(
                                        moment(s).format('YYYY'),
                                        moment(s).format('M'),
                                        moment(s).format('w')
                                    );
                                }}
                            />
                        </span>
                        {!print && <Button className="export-to-pdf" type="primary" onClick={this.onExport}>导出pdf</Button>}
                    </Row>
                    <Title />
                    <NetworkRating />
                    {/* <Day /> */}
                    <Month />
                    <Room />
                    <Food />
                    <Staff />
                    <Cost />
                </div>
            </Spin>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/BI/General/index.js